// extracted by mini-css-extract-plugin
module.exports = {"section":"_3LI-I","carouselLogos":"_2_5Ay","carouselLogoItem":"_2WjNc","videoWrapper":"_3sorC","video":"_3T4wS","heroContent":"droWo","heroImage":"_383Bl"};